import { RootState } from './store';

export const selectChat = (state: RootState) => state.chat;
export const selectChatSelectedCannedMessages = (state: RootState) => selectChat(state).selectedCannedMessages;
export const selectChatRoomTagNames = (state: RootState) => selectChat(state).roomTagNames;
